import { useMutation, useQueryClient } from "@tanstack/react-query";
import ordersClient from "../../../api/order";
import { Order } from "../../../api/order";

const useUpdateOrderManualOverrideMutation = (orderId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (manualOverride: boolean) =>
      ordersClient.updateOrderManualOverride(orderId, manualOverride),
    onSuccess: (updatedOrder: Order) => {
      queryClient.setQueryData(["order", orderId], updatedOrder);

      queryClient.invalidateQueries({ queryKey: ["orders"] });
    },
  });
};

export default useUpdateOrderManualOverrideMutation;
